import { FlexContainer, Layout } from '@taxdown/piccolo-web';
import styled from 'styled-components';

export const QuizResultContent = styled(FlexContainer)`
  background: ${({ theme: { system } }) => system.background.fds_sys_color_background_selected};
  padding: ${({ theme: { reference } }) => reference.dimension_16};
  height: 90%;
`;

export const CorrectsAnswers = styled(FlexContainer)<{ $correctAnswers: number }>`
  border-radius: ${({ theme: { system } }) => system.fds_sys_borderradius_L};
  background: ${({ theme: { system }, $correctAnswers }) =>
    $correctAnswers === 0
      ? system.background.fds_sys_color_background_cold
      : system.background.fds_sys_color_background_success};
  padding: ${({ theme: { reference } }) => reference.dimension_16};
  border: ${({ theme: { system, reference }, $correctAnswers }) =>
    `${reference.dimension_01} solid ${$correctAnswers === 0 ? system.accent.fds_sys_color_accent_cold : system.border.fds_sys_color_border_success}`};
`;

export const ExtraInfo = styled(Layout.Grid)`
  border-radius: ${({ theme: { system } }) => system.fds_sys_borderradius_L};
  background: ${({ theme: { system } }) => system.background.fds_sys_color_background_primary};
  padding: ${({ theme: { reference } }) => reference.dimension_16};
  border: none;
  max-width: 480px;
`;

export const ButtonContainer = styled(FlexContainer)`
  background: ${({ theme: { system } }) => system.background.fds_sys_color_background_primary};
  padding: ${({ theme: { reference } }) => reference.dimension_16};
`;

export const QuizResultContainer = styled(FlexContainer)`
  background: ${({ theme: { system } }) => system.background.fds_sys_color_background_selected};
  height: 85%;
`;
